import { Box } from "@mittwald/flow-components/dist/components/Box";
import { Button } from "@mittwald/flow-components/dist/components/Button";
import useFormContext from "@mittwald/flow-components/dist/components/Form/hooks/useForm/context";
import type { FC } from "react";
import React from "react";
import type { SpaceServerArticle } from "../../../../model/article";
import OrderServerPricePreviewBox from "../../../../pages/app/server/modals/OrderServerWizard/components/OrderServerPricePreviewBox";
import type { PromoCode } from "../../../utils/promoCode";

interface Props {
  article: SpaceServerArticle;
  freeTrial: boolean;
  promotion?: PromoCode;
}

export const CtaSection: FC<Props> = (props) => {
  const { article, freeTrial, promotion } = props;
  const form = useFormContext();

  return (
    <Box _alignItems="center" _flexDirection="column">
      <OrderServerPricePreviewBox
        article={article}
        freeTrial={freeTrial}
        promotion={promotion}
      />
      <Button action={{ form }} ok text="startOrder" />
    </Box>
  );
};

export default CtaSection;
